<template>
  <div class="my-table calculateDotPage">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('calculateDot.txt1')}}</span>
        <span>{{$t('calculateDot.txt2')}} / {{$t('calculateDot.txt3')}}</span>
      </div>
      <div class="flexEnd">
        <div class="searchBtn" @click="addCalculateDot">{{$t('calculateDot.txt4')}}</div>
      </div>
    </div>
    <!-- 面包屑 -->
      <el-row :gutter="20" class="cardContent">
        <el-col :span="8" class="cardBox" v-for="(item,index) in dataList" :key="index">
          <div class="header">
           <!-- @click="goDetail" -->
            <span>{{item.calculationName}}</span>
            <div class="fr">
              <img @click="handleEdit(item)" src="@/assets/picture/icon/edit_icon.png"/>
              <img @click="handleDelete(item)" src="@/assets/picture/icon/delete_S_icon.png"/>
            </div>
          </div>
          <div class="contentBox">
            <div class="flex">
              <img class="desktopPic" src="@/assets/picture/icon/host_img.png"/>
              <div class="pt5">
                <p>
                  <span class="labelTxt fl">{{$t('calculateDot.txt5')}}</span>
                  <span class="txt fl">{{item.lanIp}}</span>
                </p>
                <p>
                  <span class="labelTxt fl">{{$t('calculateDot.txt6')}}</span>
                  <span v-if="item.online" class="txt fl"><span class="dot"></span>{{$t('calculateDot.txt7')}}</span>
                  <span v-else class="txt fl"><span class="dot greenDot"></span>{{$t('calculateDot.txt8')}}</span>
                </p>
                <!-- <p>
                  <span class="labelTxt fl">CPU核数：</span>
                  <span class="txt fl">{{item.cpus}}</span>
                </p>
                <el-slider v-model="item.cpus"></el-slider> -->
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
  </div>
</template>

<script>
  import { formatDate } from "@/plugins/date.js";
  import qs from 'qs';
  export default {
    data() {
      return {
        dataList: [],
        total: 0,
      };
    },
    created() {
      this.loadData();
    },
    methods: {
      // 计算节点列表
      async loadData() {
          const {data: res} = await this.$http.post("/calculation/list");
          if (!res.success) {
            return this.$message.error(res.message);
          }
          this.dataList = res.result;
      },
      // 跳转到详情
      goDetail(){
        this.$router.push({path: "/managementProjectDetail"});
      },
      // 新建项目
      addCalculateDot(){
        this.$router.push({path: "/editCalculateDot"});
      },
      // 编辑项目
      handleEdit(row){
         this.$router.push({path: '/editCalculateDot', query: {id: row.id}});
      },
      // 删除
      handleDelete(item){
        let id = item.id;
        this.$confirm('<p class="color666 fz14">'+this.$t('calculateDot.txt9')+'</p><p class="color999 fz14">'+this.$t('calculateDot.txt10')+'</p>', this.$t('calculateDot.txt11'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('calculateDot.txt12'),
          cancelButtonText: this.$t('calculateDot.txt13'),
          type: 'warning',
          center: true
        }).then(() => {
          this.deleteDot(id);   
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('calculateDot.txt14')
          }); 
        });
      },
      // 删除计算节点
      async deleteDot(id) {
        const {data: res} = await this.$http.post("/calculation/delete?id="+id);
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.$message({
          type: 'success',
          message: this.$t('calculateDot.txt15')
        });
        this.loadData();
      },
    },
  };
</script>

<style lang="less" scoped>
  .calculateDotPage{
    .w32{
       /deep/ .el-input,/deep/ .el-input__inner{
         width: 100% !important;
       }
     }
    .searchBox{
      /*width: 33.6rem !important;*/
      /*height: 3.2rem;*/
      .btnC{
        padding:0.6rem 2.6rem;
      }
    }
    /deep/ .el-transfer__button:first-of-type{
      display: none;
    }
    /deep/ .el-button--primary{
      width: auto;
      height: auto;
      padding:0;
      background: none;
    }
    /deep/ .el-button--primary.is-disabled{
      background: none;
      border: none;
    }
    /deep/ .el-button+.el-button{
      margin-left: 0 !important;
    }
    /deep/ .el-transfer__buttons{
      padding:0;
    }
    .tips{      
      font-size: 1.4rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #98B9FF;
      margin-top: -10px;
    }
    /deep/ .el-dialog{
      /deep/ .el-input,/deep/ .el-input__inner{
        width: 100% !important;
      }
      /deep/ .el-select{
        width: 100%;
      }
      /deep/ .el-dialog .el-dialog__body .el-select .el-input__inner, .el-dialog .el-dialog__body .el-input__inner, .el-dialog .el-dialog__body .el-input{
        border-radius: 8px; 
      }
    }
    .cardContent{
      width: 100%;
      margin-top: 1.6rem;
      margin-left: 0 !important;
      .cardBox:nth-of-type(3n+3){
        margin-right: 0;
      }
      .cardBox{
        padding:3rem !important; 
        background: #fff;
        border-radius: 3rem;
        margin-bottom: 3rem;
        margin-right: 3rem;
        width: 31.5%;
        width: 31.5%;
        .header{
          border-bottom: 1px solid #EBEEF3;
          padding-bottom: 2rem;
          span{          
            font-size: 1.4rem;
            font-weight: 400;
            color: #222;
            cursor: pointer;
          }
          img{
            width: 1.4rem;
            height: 1.8rem;
            margin-right: 2rem;
            cursor: pointer;
          }
          img:last-of-type{
            margin-right: 0;
          }
        }
        .contentBox{
          padding-top:1.6rem;
          .pt5{
            padding-top: 2.5rem;
          }
          .desktopPic{
            width: 10.2rem;
            height: 10.2rem;
            margin-right: 3rem;
          }
          p:first-of-type{
            margin-bottom:1.5rem;
          };
          p:nth-of-type(2){
            margin-bottom:1.5rem;
          };
          p{            
            font-size: 1.2rem;
            font-weight: 400;
            color: #999999;
            overflow: hidden;
            span{
              color: #666;
            }
            .dot{
              width: 1.2rem;
              height: 1.2rem;
              background: #1AA600;
              border-radius: 50%; 
              margin-right: 1.2rem;
              display: block;
              float: left;
              margin-top: 5px;
            }
          }
          .w19{
            width: 19%;
          }
          .labelTxt{            
            font-size: 1.4rem;
            margin-right: 1.4rem;
            font-weight: 400;
            color: #AEB0B9;
          }
          .greenDot{
            background: #D80000 !important;
          }
          .txt{            
            font-size: 1.4rem;
            font-weight: 400;
            color: #222222;
            line-height: 2rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
  }
</style>
